import I18N from '@leverege/i18n';
import { Dialogs } from '@leverege/ui-elements';
import { Context } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import { AllowedReducer } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import MarkAsLostDialog from './MarkAsLostDialog';
import RecovrSales from '../../util/RecovrSales';
import checkForLostRecords from '../../util/Lost';
const {
  t,
  tIcon
} = I18N.ns('recovr.actions.markAsLost.markAsLostAction');
const markAsLost = type => ({
  id: `recovr.${type}.markAsLost`,
  name: 'Mark as Lost Confirmed Driveoff',
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: `location.${type}s`,
    objectType: `${type}`
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: `company.${type}s`,
    objectType: `${type}`
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: `company.locations.${type}s`,
    objectType: `${type}`
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  appearance: ({
    context
  }) => {
    const {
      target
    } = context;
    const locatorId = target?.[0]?.data?.data?.locator?.id;
    const isPairedVehicle = locatorId ? 'Mark as Lost - Confirmed Drive Off' : 'Mark as Lost';
    return {
      icon: tIcon('appearanceIcon'),
      name: t('name', {
        isPairedVehicle
      })
    };
  },
  prepare: async cxt => {
    const targets = Context.getTargetsOfType(cxt, `${type}`);
    if (targets == null || targets.length === 0) {
      return false;
    }

    // if its a vehicle, check to make sure they all have locators paired before allowing action
    const locatorId = type === 'locator' ? targets[0]?.id : targets[0]?.data?.data?.locator?.id;
    if (!locatorId) {
      return false;
    }
    const companyId = targets[0]?.data?.data?.company?.id;
    const locationId = targets[0]?.data?.data?.location?.id;
    return RecovrSales.canMarkAsLost({
      companyId,
      locationId,
      locatorId
    });
  },
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, `${type}`);
    if (targets == null || targets.length === 0) {
      return true;
    }
    const locatorId = type === 'locator' ? targets[0]?.id : targets[0]?.data?.data?.locator?.id;
    if (!locatorId) {
      return true;
    }
    const a = AllowedReducer.get(GlobalState.get(), locatorId);
    return a.markAsLost != null;
  },
  perform: async props => {
    const {
      context
    } = props;
    const devices = Context.getTargetsOfType(context, `${type}`);
    const actions = DataSources.getActions(devices[0]);
    if (!devices[0]) {
      return;
    }
    // get locator data if its a vehicle
    let vehicleLocator;
    if (devices.length === 1 && type === 'vehicle') {
      vehicleLocator = devices[0].data?.data?.locator;
    }
    const cmp = MarkAsLostDialog;
    Dialogs.show({
      id: 'markAsLost',
      component: cmp,
      props: {
        actions,
        devices,
        type,
        context,
        vehicleLocator
      }
    });
  }
});
const markVehicleAsLost = {
  id: 'recovr.vehicle.markAsLost',
  layout: {
    sort: 'vehicle.zmarkAsLost',
    sectionName: 'Sales'
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'vehicle');
    // make sure each vehicle selected is paired with a locator
    let allPaired = true;
    // loop through all and make sure none are currently lost
    const locators = targets?.map(vehicle => {
      if (vehicle?.data?.data?.locator) {
        return vehicle.data.data.locator;
      }
      allPaired = false;
      return null;
    });
    const {
      hasAtLeastOneLost
    } = checkForLostRecords(locators);
    if (targets == null || targets.length === 0 || !allPaired || hasAtLeastOneLost) {
      return false;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.data?.data?.locator?.id);
    return a.markAsLost === true && !hasAtLeastOneLost && !(targets?.[0]?.data?.data?.saleState === 'pendingReplaceLocator');
  },
  ...markAsLost('vehicle')
};
const markLocatorAsLost = {
  id: 'recovr.locator.markAsLost',
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'locator');
    // loop through all and make sure none are currently lost
    const {
      hasAtLeastOneLost
    } = checkForLostRecords(targets);
    if (targets == null || targets.length === 0 || hasAtLeastOneLost) {
      return false;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.markAsLost === true && !hasAtLeastOneLost;
  },
  ...markAsLost('locator')
};
export default {
  markLocatorAsLost,
  markVehicleAsLost
};